module.exports = __webpack_public_path__ + "static/img/logo104.a1eebd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo104.png
// module id = SbN8
// module chunks = 1